// extracted by mini-css-extract-plugin
module.exports = {"custom_checkbox":"CheckBox_custom_checkbox__11AY-","checkbox":"CheckBox_checkbox__1aeRF"};